/* eslint-disable */
var icon = require('vue-svgicon')
icon.register({
  'authorize': {
    width: 16,
    height: 16,
    viewBox: '0 0 49 52',
    data: '<defs><radialGradient id="未命名的渐变_24" cx="21.79" cy="26.68" r="22.64" gradientUnits="userSpaceOnUse"><stop offset="0" stop-color="#9abefc"/><stop offset=".97" stop-color="#4782fd"/></radialGradient><linearGradient id="未命名的渐变_56" x1="15.13" y1="37.88" x2="30.32" y2="37.88" gradientTransform="rotate(45 26.81 55.405)" gradientUnits="userSpaceOnUse"><stop offset=".7" stop-color="#4782fd"/><stop offset="1" stop-color="#9abefc"/></linearGradient></defs><path pid="0" class="cls-1" d="M41.15 31.66l-.64-.6a23.33 23.33 0 0 0-6.87-4.27 14.22 14.22 0 1 0-18.37.36A23.4 23.4 0 0 0 1.52 48.46a3 3 0 0 0 6 0 17.38 17.38 0 0 1 29-12.92L37 36a3 3 0 0 0 4.17-4.31zM24.25 7.91A8.23 8.23 0 1 1 16 16.14a8.24 8.24 0 0 1 8.25-8.23z"/><path pid="1" class="cls-2" d="M34.64 51.29a3 3 0 0 1-2.12-.88L26 43.91a3 3 0 0 1 4.24-4.24l4.4 4.33 7.72-7.72a3 3 0 0 1 4.24 4.24l-9.84 9.84a3 3 0 0 1-2.12.93z"/>'
  }
})



// WEBPACK FOOTER //
// ./src/views/icons/authorize.js